module.exports = __webpack_public_path__ + "img/logo-header.ada25463.png";